var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbol1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 64,
    viewBox: "0 0 73 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 63.5V14H18.25V7.25C18.25 3.59375 21.2031 0.5 25 0.5H47.5C51.1562 0.5 54.25 3.59375 54.25 7.25V14H58.75V63.5H13.75ZM27.25 9.5V14H45.25V9.5H27.25ZM72.25 20.75V56.75C72.25 60.5469 69.1562 63.5 65.5 63.5H63.25V14H65.5C69.1562 14 72.25 17.0938 72.25 20.75ZM9.25 63.5H7C3.20312 63.5 0.25 60.5469 0.25 56.75V20.75C0.25 17.0938 3.20312 14 7 14H9.25V63.5ZM49.75 34.25C49.75 33.125 48.625 32 47.5 32H40.75V25.25C40.75 24.125 39.625 23 38.5 23H34C32.7344 23 31.75 24.125 31.75 25.25V32H25C23.7344 32 22.75 33.125 22.75 34.25V38.75C22.75 40.0156 23.7344 41 25 41H31.75V47.75C31.75 49.0156 32.7344 50 34 50H38.5C39.625 50 40.75 49.0156 40.75 47.75V41H47.5C48.625 41 49.75 40.0156 49.75 38.75V34.25Z",
    fill: "#5E2866"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbol1);
export default __webpack_public_path__ + "static/media/Symbol (1).365dcd71df165766be80739c5983e685.svg";
export { ForwardRef as ReactComponent };